export const movies = [
  {
    id: 1,
    title: "长安十二时辰",
    slug: "changan-twelve-hours",
    category: "drama",
    categoryName: "电视剧",
    year: 2019,
    rating: 8.2,
    description: "唐朝天宝三年，上元节前夕，长安城陷入一场巨大的危机之中。死囚张小敬临危受命，与靖安司司丞李必携手，在十二个时辰内揭穿了一场足以颠覆大唐的惊天阴谋。",
    longDescription: "天宝三载，上元节前夕，长安城繁华似锦。然而在这片繁荣之下，一场惊天阴谋正在悄然酝酿。突厥、狼卫、绑架、暗杀……所有线索都指向了即将到来的上元灯会。\n\n死囚张小敬，曾经是西域老兵，因罪入狱。靖安司司丞李必，少年得志却心怀天下。两个性格迥异的人，在十二个时辰内，必须联手阻止这场可能毁灭整个长安的阴谋。\n\n从地下城到望楼，从西市到东市，从平民百姓到达官显贵，每一刻都在与时间赛跑。当真相一步步揭开，他们发现，这场阴谋背后隐藏的秘密，远比想象中更加惊人。",
    poster: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20drama%20poster%20with%20warrior%20in%20Tang%20dynasty%20armor%20holding%20sword%2C%20dark%20atmospheric%20background%20with%20ancient%20city%20silhouette%20at%20night%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20red%20and%20gold%20accents%2C%20clean%20centered%20layout&width=600&height=800&seq=poster-drama-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20Tang%20dynasty%20cityscape%20at%20night%20with%20lanterns%20and%20crowded%20streets%2C%20cinematic%20widescreen%20composition%2C%20warm%20golden%20lighting%2C%20atmospheric%20mist%2C%20grand%20scale%20historical%20setting&width=1600&height=700&seq=banner-drama-01&orientation=landscape",
    episodes: 48,
    status: "已完结",
    tags: ["古装", "悬疑", "历史", "动作"],
    director: "曹盾",
    cast: ["雷佳音", "易烊千玺", "周一围", "热依扎"],
    region: "中国大陆"
  },
  {
    id: 2,
    title: "狂飙",
    slug: "the-knockout",
    category: "drama",
    categoryName: "电视剧",
    year: 2023,
    rating: 8.5,
    description: "以一线刑警安欣为代表的正义力量，与以高启强为代表的黑恶势力展开的长达二十年的生死搏斗，全景式展现了扫黑除恶的艰辛历程。",
    longDescription: "2000年，京海市，一个普通的鱼贩高启强因为一桩意外事件，被卷入了一场黑恶势力的漩涡之中。刑警安欣敏锐地察觉到这背后的巨大阴谋，开始了一场漫长而艰难的斗争。\n\n二十年间，高启强从一个小鱼贩逐渐成长为京海市地下势力的头号人物，而安欣则始终坚守在正义的阵地上。两人之间的较量跨越了整整二十年，最终在扫黑除恶的雷霆行动中迎来了最终的决战。",
    poster: "https://readdy.ai/api/search-image?query=Modern%20Chinese%20crime%20drama%20poster%20with%20two%20men%20facing%20each%20other%20in%20tense%20standoff%2C%20dark%20urban%20background%20with%20rain%2C%20noir%20cinematic%20style%2C%20strong%20contrast%20lighting%2C%20red%20and%20black%20color%20scheme&width=600&height=800&seq=poster-drama-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Dark%20rainy%20urban%20Chinese%20city%20street%20at%20night%20with%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20cinematic%20widescreen%2C%20moody%20dramatic%20lighting&width=1600&height=700&seq=banner-drama-02&orientation=landscape",
    episodes: 39,
    status: "已完结",
    tags: ["刑侦", "扫黑", "剧情", "悬疑"],
    director: "徐纪周",
    cast: ["张译", "张颂文", "李一桐", "张志坚"],
    region: "中国大陆"
  },
  {
    id: 3,
    title: "繁花",
    slug: "blossoms-shanghai",
    category: "drama",
    categoryName: "电视剧",
    year: 2023,
    rating: 8.7,
    description: "九十年代的上海，阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。黄河路上，人人都在讲述着属于自己的繁花故事。",
    longDescription: "1990年代的上海，处处是机遇，处处是传奇。阿宝从一个普通的上海小伙，凭借敏锐的商业嗅觉和不懈的努力，一步步成为上海滩炙手可热的商界人物。\n\n黄河路的霓虹灯下，和平饭店的觥筹交错间，阿宝经历了人生的起起落落。商场如战场，爱情如烟火，每个人都在大时代的洪流中寻找属于自己的位置。",
    poster: "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20drama%20poster%20with%20elegant%20woman%20in%20qipao%20and%20man%20in%20suit%2C%20vintage%20neon%20signs%20background%2C%20warm%20golden%20nostalgic%20tone%2C%20Wong%20Kar%20Wai%20aesthetic%2C%20soft%20glamorous%20lighting&width=600&height=800&seq=poster-drama-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=1990s%20Shanghai%20Bund%20at%20night%20with%20vintage%20neon%20signs%20and%20classic%20cars%2C%20nostalgic%20golden%20warm%20lighting%2C%20cinematic%20widescreen%2C%20elegant%20retro%20atmosphere&width=1600&height=700&seq=banner-drama-03&orientation=landscape",
    episodes: 30,
    status: "已完结",
    tags: ["都市", "商战", "年代", "爱情"],
    director: "王家卫",
    cast: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    region: "中国大陆"
  },
  {
    id: 4,
    title: "流浪地球2",
    slug: "wandering-earth-2",
    category: "movie",
    categoryName: "电影",
    year: 2023,
    rating: 8.3,
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对一场毁灭性的宇宙危机，人类再次踏上了充满未知的流浪之旅。",
    longDescription: "在不远的未来，太阳急速衰老膨胀，人类决定启动流浪地球计划，在地球表面建造上万台行星发动机，推动地球离开太阳系，前往新的家园。\n\n在这场跨越2500年的漫长旅途中，人类面临着来自宇宙深处的各种未知挑战。月球危机的突然爆发，让整个计划陷入了前所未有的困境。刘培强、图恒宇等一群勇敢的人类，在这场史诗般的旅程中，展现了人类的勇气与智慧。",
    poster: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20massive%20spaceship%20and%20earth%20in%20space%2C%20dramatic%20cosmic%20background%20with%20stars%20and%20nebula%2C%20cinematic%20blockbuster%20style%2C%20cool%20blue%20and%20warm%20orange%20contrast&width=600&height=800&seq=poster-movie-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Massive%20planetary%20engines%20on%20earth%20surface%20with%20blue%20flames%20shooting%20into%20space%2C%20epic%20sci-fi%20landscape%2C%20cinematic%20widescreen%2C%20dramatic%20cosmic%20atmosphere&width=1600&height=700&seq=banner-movie-01&orientation=landscape",
    episodes: null,
    duration: "173分钟",
    status: "已上映",
    tags: ["科幻", "灾难", "冒险", "剧情"],
    director: "郭帆",
    cast: ["吴京", "刘德华", "李雪健", "沙溢"],
    region: "中国大陆"
  },
  {
    id: 5,
    title: "满江红",
    slug: "full-river-red",
    category: "movie",
    categoryName: "电影",
    year: 2023,
    rating: 7.4,
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一个小兵与亲兵营副统领机缘巧合被裹挟进一场巨大的阴谋之中。",
    longDescription: "南宋绍兴年间，宰相秦桧率禁军前往边境与金国会谈。在会谈前夜，金国使者死在宰相驻地，所携密信不翼而飞。小兵张大与亲兵营副统领孙均被卷入这场风波，被迫在有限时间内找到凶手和密信。\n\n随着调查的深入，越来越多的秘密浮出水面。各方势力在宰相府内展开了一场惊心动魄的博弈。",
    poster: "https://readdy.ai/api/search-image?query=Historical%20Chinese%20movie%20poster%20set%20in%20Song%20dynasty%20with%20soldiers%20in%20ancient%20armor%20in%20courtyard%2C%20dark%20mysterious%20atmosphere%2C%20red%20lantern%20accents%2C%20dramatic%20shadow%20lighting&width=600&height=800&seq=poster-movie-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20courtyard%20compound%20at%20night%20with%20red%20lanterns%20and%20narrow%20corridors%2C%20mysterious%20atmospheric%20lighting%2C%20cinematic%20widescreen%2C%20historical%20Song%20dynasty%20setting&width=1600&height=700&seq=banner-movie-02&orientation=landscape",
    episodes: null,
    duration: "159分钟",
    status: "已上映",
    tags: ["悬疑", "喜剧", "历史", "剧情"],
    director: "张艺谋",
    cast: ["沈腾", "易烊千玺", "张译", "雷佳音"],
    region: "中国大陆"
  },
  {
    id: 6,
    title: "海贼王",
    slug: "one-piece",
    category: "anime",
    categoryName: "动漫",
    year: 1999,
    rating: 9.5,
    description: "少年路飞为了成为海贼王，踏上伟大航路的冒险旅程。一路上结识了众多伙伴，共同追寻各自的梦想，对抗强大的敌人。",
    longDescription: "拥有财富、名声、权力，这世界上的一切的男人——海贼王哥尔·D·罗杰，在被行刑受死之前说了一句话：想要我的宝藏吗？如果想要的话，那就到海上去找吧，我全部都放在那里。\n\n世界开始迎接大海贼时代的来临。少年蒙奇·D·路飞，因误食恶魔果实而获得了橡胶般的超能力。为了成为海贼王，他踏上了伟大航路的冒险旅程，一路集结伙伴，对抗强敌，追寻传说中的大秘宝ONE PIECE。",
    poster: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20pirate%20adventure%20poster%20with%20young%20pirate%20crew%20on%20ship%2C%20bright%20blue%20ocean%20background%2C%20colorful%20vibrant%20illustration%2C%20dynamic%20action%20pose%2C%20clean%20anime%20art%20style&width=600&height=800&seq=poster-anime-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Colorful%20pirate%20ship%20sailing%20on%20bright%20blue%20ocean%20under%20clear%20sky%20with%20fluffy%20clouds%2C%20anime%20art%20style%2C%20adventure%20atmosphere%2C%20cinematic%20widescreen&width=1600&height=700&seq=banner-anime-01&orientation=landscape",
    episodes: 1122,
    status: "连载中",
    tags: ["冒险", "热血", "友情", "奇幻"],
    director: "尾田荣一郎",
    cast: ["田中真弓", "中井和哉", "冈村明美", "山口胜平"],
    region: "日本"
  },
  {
    id: 7,
    title: "咒术回战",
    slug: "jujutsu-kaisen",
    category: "anime",
    categoryName: "动漫",
    year: 2020,
    rating: 8.8,
    description: "高中生虎杖悠仁吞下了诅咒之王两面宿傩的手指，从此踏入了咒术的世界。为了收集所有的宿傩手指，他加入了东京都立咒术高等专门学校。",
    longDescription: "在这个世界中，人类的负面情绪会化为诅咒。高中生虎杖悠仁在一次意外中，为了拯救被诅咒袭击的学长学姐，吞下了特级咒物——诅咒之王两面宿傩的手指。\n\n从此，虎杖悠仁成为了两面宿傩的容器。在最强咒术师五条悟的引导下，他进入了东京都立咒术高等专门学校，开始了收集宿傩手指、对抗诅咒的战斗之旅。",
    poster: "https://readdy.ai/api/search-image?query=Japanese%20anime%20supernatural%20action%20poster%20with%20teenage%20boy%20with%20glowing%20fist%20fighting%20dark%20monster%2C%20dynamic%20combat%20pose%2C%20dark%20urban%20background%2C%20vibrant%20red%20and%20black%20color%20scheme&width=600&height=800&seq=poster-anime-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Dark%20urban%20Tokyo%20cityscape%20at%20twilight%20with%20glowing%20supernatural%20energy%2C%20anime%20art%20style%2C%20mysterious%20atmospheric%20lighting%2C%20cinematic%20widescreen&width=1600&height=700&seq=banner-anime-02&orientation=landscape",
    episodes: 48,
    status: "连载中",
    tags: ["战斗", "热血", "奇幻", "校园"],
    director: "朴性厚",
    cast: ["榎木淳弥", "内田雄马", "濑户麻沙美", "中村悠一"],
    region: "日本"
  },
  {
    id: 8,
    title: "奔跑吧兄弟",
    slug: "running-man-china",
    category: "variety",
    categoryName: "综艺",
    year: 2024,
    rating: 7.8,
    description: "国内现象级户外竞技真人秀，明星嘉宾们在各种趣味挑战和游戏中展开激烈角逐，带给观众无限欢乐。",
    longDescription: "《奔跑吧兄弟》是国内最具影响力的户外竞技真人秀节目之一。每期节目中，固定MC与飞行嘉宾组成团队，在各种创意十足的游戏和挑战中展开竞争。\n\n从城市地标到自然风光，从智力考验到体力比拼，节目以轻松幽默的方式展现明星们真实自然的一面。撕名牌环节更是成为了经典中的经典，让无数观众为之疯狂。",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20group%20of%20celebrities%20running%20and%20laughing%20on%20colorful%20outdoor%20set%2C%20bright%20energetic%20atmosphere%2C%20fun%20game%20show%20style%2C%20warm%20sunny%20lighting&width=600&height=800&seq=poster-variety-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Colorful%20outdoor%20game%20arena%20with%20obstacles%20and%20bright%20sunny%20weather%2C%20energetic%20atmosphere%2C%20entertainment%20show%20set%2C%20cinematic%20widescreen&width=1600&height=700&seq=banner-variety-01&orientation=landscape",
    episodes: 12,
    status: "更新至第8期",
    tags: ["真人秀", "竞技", "搞笑", "户外"],
    director: "姚译添",
    cast: ["李晨", "郑恺", "杨颖", "沙溢", "白鹿", "周深"],
    region: "中国大陆"
  },
  {
    id: 9,
    title: "歌手2024",
    slug: "singer-2024",
    category: "variety",
    categoryName: "综艺",
    year: 2024,
    rating: 8.0,
    description: "殿堂级音乐竞演节目全新回归，国内外顶尖歌手同台竞技，用歌声征服舞台，为观众带来顶级的音乐盛宴。",
    longDescription: "《歌手2024》作为国内殿堂级音乐竞演节目的全新力作，汇聚了来自海内外的顶级歌手。全程无修音、真实现场演绎，每一位歌手都在舞台上倾尽全力，用最纯粹的声音打动观众。\n\n从经典老歌到原创新作，从华语流行到世界音乐，节目展现了音乐的无限可能。每一场竞演都是一次音乐的灵魂对话。",
    poster: "https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20with%20singer%20on%20grand%20stage%20under%20spotlight%2C%20dramatic%20golden%20lighting%2C%20elegant%20atmosphere%2C%20concert%20performance%20style&width=600&height=800&seq=poster-variety-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dramatic%20spotlights%20and%20smoke%20effects%2C%20golden%20warm%20lighting%2C%20elegant%20performance%20venue%2C%20cinematic%20widescreen&width=1600&height=700&seq=banner-variety-02&orientation=landscape",
    episodes: 13,
    status: "更新至第10期",
    tags: ["音乐", "竞演", "真人秀", "直播"],
    director: "洪啸",
    cast: ["那英", "汪苏泷", "杨丞琳", "海来阿木", "Faouzia"],
    region: "中国大陆"
  },
  {
    id: 10,
    title: "庆余年第二季",
    slug: "joy-of-life-2",
    category: "drama",
    categoryName: "电视剧",
    year: 2024,
    rating: 8.1,
    description: "范闲从第一季的危机中脱身，重返京都。朝堂之上的权力斗争愈发激烈，隐藏在暗处的真相正一步步浮出水面。",
    longDescription: "在第一季的结尾，范闲被言冰云一剑刺中，生死未卜。第二季中，范闲不仅成功脱险，更以全新的姿态重返京都。\n\n朝堂之上，各方势力蠢蠢欲动。范闲一边要应对来自各方的明枪暗箭，一边还要追查母亲叶轻眉之死的真相。随着调查的深入，一个惊天秘密正在逐渐浮出水面。",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20handsome%20man%20in%20elegant%20ancient%20robe%20holding%20fan%2C%20palace%20background%20with%20cherry%20blossoms%2C%20warm%20golden%20sunset%20lighting%2C%20romantic%20atmosphere&width=600&height=800&seq=poster-drama-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20courtyard%20with%20blooming%20cherry%20blossoms%20at%20sunset%2C%20warm%20golden%20lighting%2C%20elegant%20historical%20setting%2C%20cinematic%20widescreen&width=1600&height=700&seq=banner-drama-04&orientation=landscape",
    episodes: 36,
    status: "已完结",
    tags: ["古装", "权谋", "奇幻", "剧情"],
    director: "孙皓",
    cast: ["张若昀", "李沁", "陈道明", "吴刚"],
    region: "中国大陆"
  },
  {
    id: 11,
    title: "飞驰人生2",
    slug: "pegasus-2",
    category: "movie",
    categoryName: "电影",
    year: 2024,
    rating: 7.6,
    description: "曾经的赛车冠军张驰，在经历人生低谷后，决定重返赛场。面对新一代车手的挑战，他必须再次证明自己的实力。",
    longDescription: "五年前巴音布鲁克的悲剧后，张驰身心都遭受了巨大的创伤。曾经的赛车冠军沦落为驾校教练，生活平淡如水。\n\n然而，当一支濒临解散的车队找上门来，邀请他重返赛场时，张驰心中的赛车之魂再次被点燃。面对着新一代的天才车手和更加强大的对手，这位老将能否再次创造奇迹？",
    poster: "https://readdy.ai/api/search-image?query=Chinese%20racing%20comedy%20movie%20poster%20with%20race%20car%20speeding%20on%20desert%20highway%2C%20dust%20trail%20behind%2C%20warm%20sunset%20lighting%2C%20dynamic%20action%20composition%2C%20cinematic%20blockbuster%20style&width=600&height=800&seq=poster-movie-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Race%20cars%20on%20desert%20rally%20track%20at%20sunset%20with%20dust%20clouds%20and%20dramatic%20sky%2C%20cinematic%20widescreen%2C%20action%20adventure%20atmosphere&width=1600&height=700&seq=banner-movie-03&orientation=landscape",
    episodes: null,
    duration: "129分钟",
    status: "已上映",
    tags: ["喜剧", "运动", "剧情"],
    director: "韩寒",
    cast: ["沈腾", "范丞丞", "尹正", "张本煜"],
    region: "中国大陆"
  },
  {
    id: 12,
    title: "葬送的芙莉莲",
    slug: "frieren",
    category: "anime",
    categoryName: "动漫",
    year: 2023,
    rating: 9.3,
    description: "勇者一行人打败魔王后，精灵魔法使芙莉莲踏上了了解人类的旅程。在漫长的时间中，她逐渐理解了生命的意义和情感的真谛。",
    longDescription: "勇者辛美尔、僧侣海塔、战士艾泽与精灵魔法使芙莉莲，历经十年冒险，终于打败了魔王，为世界带来了和平。\n\n然而，对于寿命长达千年以上的精灵芙莉莲来说，与伙伴们共度的十年只是弹指一挥间。当五十年后她再次见到年迈的辛美尔，看着他安详离世时，芙莉莲才第一次意识到，自己从未真正了解过这个名为人类的种族。\n\n带着这份遗憾与好奇，芙莉莲踏上了了解人类的旅程。",
    poster: "https://readdy.ai/api/search-image?query=Japanese%20anime%20fantasy%20poster%20with%20elf%20girl%20in%20white%20robe%20walking%20through%20flower%20field%2C%20soft%20warm%20sunset%20lighting%2C%20nostalgic%20atmospheric%20style%2C%20beautiful%20scenery&width=600&height=800&seq=poster-anime-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=Beautiful%20fantasy%20landscape%20with%20rolling%20green%20hills%20and%20flower%20fields%20under%20golden%20sunset%20sky%2C%20anime%20art%20style%2C%20peaceful%20atmospheric%20scenery&width=1600&height=700&seq=banner-anime-03&orientation=landscape",
    episodes: 28,
    status: "已完结",
    tags: ["奇幻", "治愈", "冒险", "剧情"],
    director: "斋藤圭一郎",
    cast: ["种崎敦美", "冈本信彦", "东地宏树", "上田耀司"],
    region: "日本"
  }
];

export const categories = [
  { slug: "drama", name: "电视剧", icon: "ri-tv-line" },
  { slug: "movie", name: "电影", icon: "ri-film-line" },
  { slug: "anime", name: "动漫", icon: "ri-rocket-line" },
  { slug: "variety", name: "综艺", icon: "ri-mic-line" }
];

export const reviews = [
  { id: 1, name: "星空下的追剧人", rating: 5, content: "天美麻花真的是我见过最好的免费影视平台！画质清晰不缓冲，片源更新超快，每天晚上追剧必备！", date: "2024-07-15" },
  { id: 2, name: "电影发烧友小王", rating: 5, content: "资源太全了！好多小众电影都能找到，而且都是蓝光画质，观影体验简直不要太好！", date: "2024-07-10" },
  { id: 3, name: "追番少女小美", rating: 5, content: "作为一个二次元爱好者，这里的动漫资源真的让我惊喜。更新速度很快，画质也超级棒！", date: "2024-06-28" },
  { id: 4, name: "全家福影视迷", rating: 5, content: "一家老小都喜欢在这看，电视剧、电影、综艺什么都有，大屏TV版投到电视上看更过瘾！", date: "2024-06-15" },
  { id: 5, name: "深夜观影者", rating: 4, content: "界面简洁好用，分类清晰。最重要的是真的不缓冲，看超清蓝光电影完全没压力。", date: "2024-06-01" },
  { id: 6, name: "周末宅家族", rating: 5, content: "周末宅在家里在天美麻花上看一整天，片源多到根本看不完！强烈推荐给所有喜欢看剧的朋友！", date: "2024-05-20" }
];

export const faqs = [
  {
    question: "天美麻花星空影视是否需要注册才能观看？",
    answer: "不需要！天美麻花星空影视完全免费，无需注册即可观看所有内容。打开网站就能直接享受超清蓝光画质的电视剧、电影、综艺和动漫。"
  },
  {
    question: "天美麻花星空影视支持哪些设备观看？",
    answer: "天美麻花星空影视支持手机、平板、电脑以及大屏TV等多种设备观看。大屏TV版更能让您在家中享受影院级别的观影体验。"
  },
  {
    question: "为什么天美麻花星空影视播放不缓冲？",
    answer: "我们采用了先进的CDN加速技术和智能码率自适应方案，根据您的网络状况自动调整画质，确保流畅播放不卡顿。"
  },
  {
    question: "天美麻花星空影视的片源更新频率如何？",
    answer: "我们拥有专业的内容更新团队，热门电视剧、综艺节目基本在播出后24小时内更新，电影上线后也会第一时间同步。"
  },
  {
    question: "天美麻花星空影视的画质怎么样？",
    answer: "天美麻花星空影视提供超清蓝光画质，支持1080P和4K分辨率。配合先进的编码技术，让每一帧画面都清晰细腻。"
  }
];